module.exports = __webpack_public_path__ + "images/6b0520ac05aa91326e0a5054523fea21.png";